module.exports = __webpack_public_path__ + "static/media/numDescending.114d2b5a.svg";